import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import css_248z from './verification-gate.scss.js';

class VerificationGate extends s {
    constructor() {
        super(...arguments);
        this.mainTitle = '';
        this.subtitle = '';
        this.moreInfoText = '';
        this.moreInfoContent = '';
        this.accessInstructionText = '';
        this.loginButtonText = '';
        this.loginButtonUrl = '';
        this.loginButtonTarget = '';
        this.createAccountButtonText = '';
        this.createAccountButtonUrl = '';
        this.createAccountButtonTarget = '';
        this.notProfessionalText = '';
        this.showMoreInfoButton = true;
        this.moreInfoExpanded = false;
        this.removedContent = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.removeProtectedContent();
    }
    removeProtectedContent() {
        const mainElement = document.querySelector('main');
        const contentDiv = document.querySelector('.content, #skip-to-content');
        const preservedSelectors = [
            'verification-gate',
            '#hcp-verification-overlay',
            'script',
            'style',
            'link',
            'noscript',
        ];
        if (mainElement) {
            this.removeChildrenExcept(mainElement, preservedSelectors);
        }
        if (contentDiv) {
            this.removeChildrenExcept(contentDiv, preservedSelectors);
        }
    }
    removeChildrenExcept(parent, preservedSelectors) {
        const children = Array.from(parent.children);
        children.forEach(element => {
            const shouldPreserve = preservedSelectors.some(selector => {
                try {
                    return element.matches(selector) || element.contains(this);
                }
                catch (e) {
                    return false;
                }
            });
            if (!shouldPreserve) {
                this.removedContent.push(element);
                element.remove();
            }
        });
    }
    toggleMoreInfo(e) {
        e.preventDefault();
        this.moreInfoExpanded = !this.moreInfoExpanded;
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.moreInfoExpanded = !this.moreInfoExpanded;
        }
    }
    handleLoginButtonClick(e) {
        e.preventDefault();
        if (this.loginButtonUrl) {
            if (this.loginButtonTarget === '_blank') {
                window.open(this.loginButtonUrl, '_blank');
            }
            else {
                window.location.href = this.loginButtonUrl;
            }
        }
    }
    handleCreateAccountButtonClick(e) {
        e.preventDefault();
        if (this.createAccountButtonUrl) {
            if (this.createAccountButtonTarget === '_blank') {
                window.open(this.createAccountButtonUrl, this.createAccountButtonTarget);
            }
            else {
                window.location.href = this.createAccountButtonUrl;
            }
        }
    }
    renderAccessInstructionText() {
        if (!this.accessInstructionText) {
            return '';
        }
        return $ `<div class="access-instruction rte">${o(wrapRichTextTables(this.accessInstructionText))}</div>`;
    }
    renderNotProfessionalText() {
        if (!this.notProfessionalText) {
            return '';
        }
        return $ `<div class="footer"><div class="non-hcp-content rte">${o(wrapRichTextTables(this.notProfessionalText))}</div></div>`;
    }
    renderMoreInfoContent() {
        if (!this.moreInfoContent) {
            return '';
        }
        return $ `<div class="more-info-content" id="more-info-content"><div class="rte">${o(wrapRichTextTables(this.moreInfoContent))}</div></div>`;
    }
    renderMoreInfo() {
        if (!this.showMoreInfoButton ||
            !this.moreInfoText ||
            !this.moreInfoContent) {
            return '';
        }
        const toggleIcon = this.moreInfoExpanded ? '−' : '+';
        const ariaExpanded = this.moreInfoExpanded ? 'true' : 'false';
        return $ `<div class="more-info-container"><div @click="${this.toggleMoreInfo}" @keydown="${this.handleKeyDown}" class="more-info-header" tabindex="0" role="button" aria-expanded="${ariaExpanded}" aria-controls="more-info-content"><span class="more-info-text">${this.moreInfoText}</span> <span class="toggle-icon">${toggleIcon}</span></div>${this.moreInfoExpanded ? this.renderMoreInfoContent() : ''}</div>`;
    }
    render() {
        return $ `<div class="page-block"><div class="verification-gate"><div class="vg__header"><h1 class="vg__title">${this.mainTitle}</h1></div><div class="vg__body"><div class="vg__subtitle rte">${o(wrapRichTextTables(this.subtitle))}</div>${this.renderMoreInfo()} ${this.renderAccessInstructionText()}</div><div class="vg__footer"><div class="vg__buttons"><button class="login-button" aria-label="${this.loginButtonText}" @click="${this.handleLoginButtonClick}">${this.loginButtonText}</button> <button class="create-account-button" aria-label="${this.createAccountButtonText}" @click="${this.handleCreateAccountButtonClick}">${this.createAccountButtonText}</button></div>${this.renderNotProfessionalText()}</div></div></div>`;
    }
}
VerificationGate.styles = css_248z;
__decorate([
    e({ type: String })
], VerificationGate.prototype, "mainTitle", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "subtitle", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "moreInfoText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "moreInfoContent", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "accessInstructionText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonUrl", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "loginButtonTarget", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonText", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonUrl", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "createAccountButtonTarget", void 0);
__decorate([
    e({ type: String })
], VerificationGate.prototype, "notProfessionalText", void 0);
__decorate([
    e({ type: Boolean })
], VerificationGate.prototype, "showMoreInfoButton", void 0);
__decorate([
    t()
], VerificationGate.prototype, "moreInfoExpanded", void 0);
customElements.define('verification-gate', VerificationGate);

export { VerificationGate };
